<script lang="ts">
  import flatpickr from 'flatpickr'
  import 'flatpickr/dist/flatpickr.css'
  import { onMount } from 'svelte'

  let {
    id = '',
    value = $bindable(''),
    format = 'mm/dd/yyyy',
    editable = false,
    required = false,
  } = $props()

  let el
  let fp;

  onMount(() => {
    fp = flatpickr(el, {
      dateFormat: format,
      enableTime: false,
      onChange(selectedDates, dateStr) {
        value = dateStr
      },
    })
  })

  function open(evt) {
    evt.preventDefault();
    fp?.open()
  }
</script>

<div>
  <input
    {id}
    class="form-control"
    {value}
    bind:this={el}
    data-lpignore
    {required}
    type="text"
  />

  {#if editable}
    <button
      type="button"
      class="datepicker-trigger"
      onclick={open}
      aria-label="Open date picker"
    >&nbsp;</button>
  {/if}
</div>
